var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookMarkHollow = function SvgIconBookMarkHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.333 11.483 5 9.933l3.666 1.55V1.916H1.333v9.567Zm-.3 1.217a.457.457 0 0 1-.475-.034.474.474 0 0 1-.225-.416V1.916c0-.266.1-.5.3-.7.2-.2.433-.3.7-.3h7.333c.267 0 .5.1.7.3.2.2.3.434.3.7V12.25a.474.474 0 0 1-.225.416.457.457 0 0 1-.475.034L5 11l-3.967 1.7Zm.3-10.784h7.333-7.333Z",
    fill: "#4F52C3"
  })));
};
export default SvgIconBookMarkHollow;